($ => {
  /**
   * window jQuery Object
   * @type {jQuery}
   */
  const $window = $(window)

  $(() => {

    /**
     * 数値をカンマ付きの文字列に変換
     * @param {Number} num - 変換対象の数値 
     */
    const setComma = num => String(num).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')

    /**
     * スコープへの配慮のため、関数を格納する変数を用意
     */
    var fixCartInArea;

    /**
     * カートエリアの画面内固定表示を設定
     */
    const setFixCartInArea = () => {

      /**
       * .productOrder__bodyのjQueryオブジェクト
       * @type {jQuery}
       */
      const $productOrderBody = $('.productOrder__body')

      /**
       * カートエリアのjQueryオブジェクト
       * @type {jQuery}
       */
      const $cartInArea = $('.cartInArea')

      /**
       * カートエリアの画面内固定表示に対応
       */
      fixCartInArea = () => {
        const orderBodyHeight = $productOrderBody.outerHeight()
        const orderBodyOffsetTop = $productOrderBody.offset().top
        const cartInAreaHeight = $cartInArea.outerHeight()
        let windowScrollTop = $window.scrollTop()
        if ($window.width() > 1024) {
          windowScrollTop = windowScrollTop + $(".l-navi__main").height() + 24
        } else {
          windowScrollTop = windowScrollTop + $(".l-header").height() + 12
        }
        
        if (windowScrollTop >= orderBodyOffsetTop) {
          $cartInArea.addClass("is-fixed")
        } else {
          $cartInArea.removeClass("is-fixed")
        }
        if ((orderBodyOffsetTop + orderBodyHeight) - (windowScrollTop + cartInAreaHeight) < 0) {
          $cartInArea.addClass("is-positionBottom")
        } else {
          $cartInArea.removeClass("is-positionBottom")
        }
      }
    }

    /**
     * スマホでのテーブルフリックに対応
     */
    const setFlickableTable = () => {
      const $selectTable = $('.selectTable')
      const $selectTable__header = $('.selectTable__header')
      const $selectTable__inner = $('.selectTable__inner')
      const $selectTable__head = $selectTable.find('.selectTable__header__item--head, th')
      let swipeData = {}
      let isRunningTouchmove = true;
      $selectTable.css({
        "height": ($selectTable__header.outerHeight() + $selectTable__inner.outerHeight()) + "px",
        "overflow": "hidden",
        "position": "relative"
      })
      $selectTable__header.css({
        "position": "absolute",
        "top": "0",
        "left": "0"
      })
      $selectTable__inner.css({
        "position": "absolute",
        "top": $selectTable__header.outerHeight() + "px",
        "left": "0"
      })
      $selectTable
        .on(EVENT.TOUCH_START, (e) => {
          swipeData = {
            "left": Number(String($selectTable__header.css('left')).replace('px', '')),
            "pageX": e.originalEvent.pageX ? e.originalEvent.pageX : e.originalEvent.changedTouches[0].pageX
          }
        })
        .on(EVENT.TOUCH_MOVE, (e) => {
          if (isRunningTouchmove) {
            isRunningTouchmove = false
            requestAnimationFrame(() => {
              isRunningTouchmove = true
              if ('pageX' in swipeData) {
                let pageX = e.originalEvent.pageX ? e.originalEvent.pageX : e.originalEvent.changedTouches[0].pageX
                if (swipeData.left + pageX - swipeData.pageX > 0) {
                  $selectTable__header.css({
                    "left": "0"
                  })
                  $selectTable__inner.css({
                    "left": "0"
                  })
                  $selectTable__head.css({
                    "left": "0"
                  })
                } else if (swipeData.left + pageX - swipeData.pageX < -($selectTable__header.outerWidth() - $selectTable.outerWidth())) {
                  const positionLeft = -($selectTable__header.outerWidth() - $selectTable.outerWidth())
                  $selectTable__header.css({
                    "left": positionLeft + "px"
                  })
                  $selectTable__inner.css({
                    "left": positionLeft + "px"
                  })
                  $selectTable__head.css({
                    "left": -positionLeft + "px"
                  })
                } else {
                  const positionLeft = (swipeData.left + pageX - swipeData.pageX)
                  $selectTable__header.css({
                    "left": positionLeft + "px"
                  })
                  $selectTable__inner.css({
                    "left": positionLeft + "px"
                  })
                  $selectTable__head.css({
                    "left": -positionLeft + "px"
                  })
                }
              }
            })
          }
        })
        .on(EVENT.TOUCH_END, (e) => {
          if ('pageX' in swipeData) {
            let pageX = e.originalEvent.pageX ? e.originalEvent.pageX : e.originalEvent.changedTouches[0].pageX
            if (swipeData.left + pageX - swipeData.pageX > 0) {
              $selectTable__header.css({
                "left": "0"
              })
              $selectTable__inner.css({
                "left": "0"
              })
              $selectTable__head.css({
                "left": "0"
              })
            }
            if (swipeData.left + pageX - swipeData.pageX < -($selectTable__header.outerWidth() - $selectTable.outerWidth())) {
              const positionLeft = -($selectTable__header.outerWidth() - $selectTable.outerWidth())
              $selectTable__header.css({
                "left": positionLeft + "px"
              })
              $selectTable__inner.css({
                "left": positionLeft + "px"
              })
              $selectTable__head.css({
                "left": -positionLeft + "px"
              })
            }
            swipeData = {}
          }
        })
    }

    setFixCartInArea()
    
    if ('ontouchstart' in window) {
      setFlickableTable()
    }

    /**
     * 実行中かどうか
     * @type {Boolean}
     */
    let isRunning = false
  
    /**
     * スクロール時に実行
     */
    const onScroll = () => {
      fixCartInArea()
    }
  
    onScroll()
  
    $window.on('scroll', () => {
      if (!isRunning) {
        isRunning = true;
        requestAnimationFrame(() => {
          isRunning = false
          onScroll()
        })
      }
    })

    /*-- ↓↓ここから商品選択のスクリプト↓↓ --*/

    /**
     * フォームのSKU ID を更新
     * @param {Number} id - SKU ID
     */
    const updateFormSkuInput = (id) => {
      $('#skuForm').empty()
      $('#skuForm').html('<input type="hidden" name="product_sku_id" value="' + id + '" class="productInput"><input type="hidden" name="quantity" value="1">')
    }

    if(!isSimpleOrder) {
      //通常商品の選択フォーム

      /**
       * 選択されている商品のデータ
       * @type {Object}
       */
      let selectedProductData = {
        "step": 3, // 選択中のステップ
        "step_checked": {
          "step1": true,
          "step2": false,
          "step3": true
        },
        "step_selected": [
          // STEP1
          {
            "reqMethod": false, // 依頼方法
            "weight": {
              "label": $('input[name="weight"]:checked').val(),
              "product_id": $('input[name="weight"]:checked').data('product'),
              "price": 0
            }, // 用紙厚さ
            "plan": false, // 印刷プラン
            "flextype": false // 折り方
          },
          // STEP2
          {
            "sku": false // 部数・納期（商品本体）
          },
          // STEP3
          {
            "paper": false, // 用紙の種類
            "cuttype": false, // 加工タイプ
            "delivery": false // 納品方法
          }
        ],
        "address_print" : {
          "is_active": false, // 宛名印字が有効ならtrue
          "sku_id": false, // 宛名印字の SKU ID
          "add_date": false, // 宛名印字の追加納期
          "label": false // 宛名印字の追加納期
        },
        /**
         * オブジェクト内から、該当キーを検索しプロパティを取得
         * @param  {String} key 検索するキー
         * @return {Object|Boolean} 該当キーのプロパティの値。該当キーが見つからない場合、falseを返す
         */
        "get": function (key) {
          let _self = this
          let target = _self.find(key)
          if (target) {
            return target.parent[target.key]
          } else {
            return false
          }
        },
        /**
         * オブジェクト内から、該当キーを検索し指定のプロパティを設定
         * @param  {String} key 検索するキー
         * @param  {Object} value 設定するプロパティ
         * @return {Boolean} 設定できたらtrue、該当キーが見つからない場合はfalseを返す
         */
        "set": function (key, value) {
          let _self = this
          let target = _self.find(key)
          if (target) {
            target.parent[target.key] = value;
            return true
          } else {
            return false
          }
        },
        /**
         * オブジェクト内から、該当キーを検索し削除
         * @param  {String} key 検索するキー
         * @return {Boolean} 削除できたらtrue、該当キーが見つからない場合はfalseを返す
         */
        "remove": function (key) {
          let _self = this
          let target = _self.find(key)
          if (target) {
            delete target.parent[target.key];
            return true
          } else {
            return false
          }
        },
        /**
         * オブジェクト内から、該当キーを検索
         * @param  {String} key 検索するキー
         * @return {Object|Boolean} 該当キーが見つかったら、該当キーの親オブジェクトとキーをオブジェクトに格納して返し、見つからなければfalseを返す
         */
        "find": function(key) {
          let _self = this
          for (let i in _self) {
            if (i === key) {
              return {
                "parent": _self,
                "key": i
              }
            }
            if (Array.isArray(_self[i])) {
              for (let ii = 0; ii < _self[i].length; ii++) {
                for (let iii in _self[i][ii]) {
                  if (iii === key) {
                    return {
                      "parent": _self[i][ii],
                      "key": iii
                    }
                  }
                }
              }
            }
          }
          return false;
        }
      }
      
      //オプション商品のフォーム設定
      const setAddionsForm = () => {
        $('#addions').empty()
        $('input[data-id]:checked').each(function () {
          const $self = $(this)
          $('#addions').append('<input type="hidden" name="addition_quantity[' + $self.data('id') + ']" value="1">')
        })
      }

      // 部数・納期一覧の価格を更新
      const updatePrices = () => {
        $('.selectTable__price').each(function() {
          let $self = $(this)
          let selfData = $self.parent().data('skuinfo')
          $self.text(setComma(products[selectedProductData.get('weight').label].find(selfData.copies, selfData.course).price))
        });
      }

      // 宛名印字の価格を更新
      const updateAddresPrintPrices = () => {
        $('.selectTable__price--hasAddress').each(function() {
          let $self = $(this)
          let selfData = $self.parent().data('skuinfo')
          let price = products[selectedProductData.get('weight').label].find(selfData.copies, selfData.course).price
          $self.text(setComma(price + addresPrintProducts[selfData.copies].price))
        });
      }

      // SKU Update
      const updateSku = () => {
        if ($('.js-selectProduct.is-selected').length) {
          let selfData = $('.js-selectProduct.is-selected').data('skuinfo')
          let selectedProduct = products[selectedProductData.get('weight').label].find(selfData.copies, selfData.course)
          selectedProductData.set('sku', {
            "id": products[selectedProductData.get('weight').label].id,
            "label": selectedProduct.copies + '枚 ' + selectedProduct.course,
            "price": selectedProduct.price,
            "sku_id": selectedProduct.id,
            "copies": selectedProduct.copies,
            "course": selectedProduct.course
          })
          updateFormSkuInput(selectedProduct.id)
        }
        $('#cartinForm').attr('action', products[selectedProductData.get('weight').label].cart_add_url)
      }

      /**
       * 用紙の種類「お任せコース」確認
       */
      const checkPaperRandom = () => {
        /**
         * @type {jQuery} 用紙の種類「お任せコース」チェックボックスのjQueryオブジェクト
         */
        const $paperRandom = $('#paperRandom')
        if ($paperRandom.length) {
          const selectedProductDataSku = selectedProductData.get('sku')
          if (selectedProductDataSku) {
            // 部数・納期で「5日出荷」が選択されていたときの処理
            if (selectedProductDataSku.course === '5日出荷') {
              // 例外に該当する場合の処理
              if (selectedProductDataSku.id in exceptionPaperRandom) {
                if (exceptionPaperRandom[selectedProductDataSku.id] <= Number(String(selectedProductDataSku.copies).replace(',', ''))) {
                  cancelPaperRandom()
                } else {
                  setPaperRandom()
                }
              } else {
                setPaperRandom()
              }
            } else {
              cancelPaperRandom()
            }
          }
        }
        /**
         * 「お任せコース」に用紙の種類を固定
         */
        function setPaperRandom () {
          $('input[name="paper"]').not($paperRandom)
            .prop('checked', false)
            .addClass('is-disabled')
            .attr('disabled', true)
          $paperRandom
            .prop('checked', true)
            .trigger('click')
          selectedProductData.set('paper', {
            "label": $paperRandom.val(),
            "id": $paperRandom.data('id'),
            "price": $paperRandom.data('price')
          })
        }
        /**
         * 「お任せコース」への用紙の種類固定を解除
         */
        function cancelPaperRandom () {
          $('input[name="paper"]').not($paperRandom)
            .removeClass('is-disabled')
            .attr('disabled', false)
        }
      }

      /**
       * 依頼方法を選択したときの動作
       */
      const changeReqMethod = () => {
        const $selectedReqMethod = $('input[name="reqMethod"]:checked')
        return {
          "label": $selectedReqMethod.val(),
          "product_id": $selectedReqMethod.data('product'),
          "price": 0
        }
      }

      /**
       * 用紙厚さを選択したときの動作
       */
      const changeWeight = () => {
        const $selectedWeight = $('input[name="weight"]:checked')
        $('.js-changeWeight').text($selectedWeight.val())
        return {
          "label": $selectedWeight.val(),
          "product_id": $selectedWeight.data('product'),
          "price": 0
        }
      }

      /**
       * 印刷プランを選択したときの動作
       */
      const changePlan = () => {
        const $selectedPlan = $('input[name="plan"]:checked')
        /**
         * 選択された印刷プラン名
         * @type {String}
         */
        const label = $selectedPlan.val()
        if (label === '印刷・圧着・発送まで') {
          selectedProductData.address_print.is_active = false;
          $('.selectTable__price').show()
          $('.selectTable__price--hasAddress').hide()
        } else {
          selectedProductData.address_print.is_active = true;
          $('.selectTable__price').hide()
          $('.selectTable__price--hasAddress').show()
        }
        if (label == '投函まで') {
          $('#addions').append('<input type="hidden" name="addition_quantity[' + $selectedPlan.data('id') + ']" value="1">')
          return {
            "label": label + '<small>' + $('#planToPost').data('note') + '</small>',
            "id": $selectedPlan.data('id'),
            "price": $selectedPlan.data('price')
          }
        } else {
          return {
            "label": label,
            "price": 0
          }
        }
      }

      /**
       * カートインエリアの内容を更新
       */
      const updateCartInArea = () => {
        for (let i = 0; i < selectedProductData.step_selected.length; i++) {
          for (var ii in selectedProductData.step_selected[i]) {
            let $target = $('[data-name="' + ii + '"]');
            if (selectedProductData.step_selected[i][ii]) {
              if ($target.data('name') === 'sku' && selectedProductData.address_print.is_active) {
                // 宛名が有効の場合、宛名の追加納期を「部数・納期」のラベルに追加
                $target.find('.js-selectedLabel')
                  .html(selectedProductData.step_selected[i][ii].label + '<small>(宛名の追加納期: +' + selectedProductData.address_print.add_date + '日)</small>')
                  .removeClass("is-unselected")
                $target.find('.js-selectedPrice').text(setComma(selectedProductData.step_selected[i][ii].price + addresPrintProducts[selectedProductData.address_print.label].price))
              } else {
                // if ($target.data('name') === 'paper') {
                //   // 「用紙の種類」のラベルに、用紙の厚さを追記
                //   $target.find('.js-selectedLabel')
                //     .html(selectedProductData.step_selected[i][ii].label + selectedProductData.get('weight').label)
                //     .removeClass("is-unselected")
                // } else {
                  $target.find('.js-selectedLabel')
                    .html(selectedProductData.step_selected[i][ii].label)
                    .removeClass("is-unselected")
                // }
                $target.find('.js-selectedPrice').text(setComma(selectedProductData.step_selected[i][ii].price))
              }
            } else {
              $target.find('.js-selectedLabel')
                .html('未選択')
                .addClass("is-unselected")
              $target.find('.js-selectedPrice').text('-')
            }
          }
        }
      }

      /**
       * STEP 2 へ移動
      */
      const gotoStep2 = () => {
        selectedProductData.step = 2
      }

      /**
       * STEP 3 へ移動
      */
      const gotoStep3 = () => {
        selectedProductData.step = 3
      }

      /**
       * ステップの進行状況を確認
       */
      const checkStep = () => {
        let isCompleted = {
          "step1": true,
          "step2": true,
          "step3": true
        }
        for (let key in selectedProductData.step_selected[0]) {
          if (!selectedProductData.step_selected[0][key]) {
            isCompleted.step1 = false
          }
        }
        for (let key in selectedProductData.step_selected[1]) {
          if (!selectedProductData.step_selected[1][key]) {
            isCompleted.step2 = false
          }
        }
        for (let key in selectedProductData.step_selected[2]) {
          if (!selectedProductData.step_selected[2][key]) {
            isCompleted.step3 = false
          }
        }
        if(selectedProductData.step_checked.step1) {
          $('.orderStatus').eq(0).addClass('is-checked')
        }
        if (isCompleted.step1) {
          if (selectedProductData.step === 1) {
            if (!isCompleted.step2) {
              gotoStep2()
            } else {
              if (!isCompleted.step3) {
                gotoStep3()
              }
            }
          }
        }
        if(selectedProductData.step_checked.step2) {
          $('.orderStatus').eq(1).addClass('is-checked')
        }
        if (isCompleted.step2) {
          if (selectedProductData.step === 2) {
            if (!selectedProductData.step_checked.step3) {
              gotoStep3()
              selectedProductData.step_checked.step3 = true
            }
          }
        }
        if (selectedProductData.step_checked.step2) {
          $('.orderStatus').eq(2).addClass('is-checked')
        }
        if (isCompleted.step1 && isCompleted.step2 &&isCompleted.step3) {
          let totalPrice = 0
          for (let i = 0; i < selectedProductData.step_selected.length; i++) {
            for (let ii in selectedProductData.step_selected[i]) {
              totalPrice += selectedProductData.step_selected[i][ii].price
            }
          }
          if (selectedProductData.address_print.is_active) {
            totalPrice += addresPrintProducts[selectedProductData.address_print.label].price
          }
          $('.js-totalPrice').text(setComma(totalPrice))
          $('.js-cartInButton')
            .removeClass('is-disabled')
            .prop('disabled', false)
        } else {
          $('.js-totalPrice').text('-')
          $('.js-cartInButton')
            .addClass('is-disabled')
            .prop('disabled', true)
        }
      }

      // フォーム変更時に実行するスクリプト
      $window.on('optionschange', () => {
        checkPaperRandom()
        updateCartInArea()
        checkStep()
        setAddionsForm()
      })

      /**
       * 起動時に実行するスクリプト
       */
      const initProductDetail = () => {
        //宛名印字の追加納期を設定
        for (let i in addresPrintProducts) {
          let copiesNum = Number(String(i).replace(',', ''))
          if (copiesNum <= 20000) {
            addresPrintProducts[i]['add_date'] = 2
          } else if (copiesNum <= 40000) {
            addresPrintProducts[i]['add_date'] = 3
          } else if (copiesNum <= 50000) {
            addresPrintProducts[i]['add_date'] = 4
          } else if (copiesNum <= 60000) {
            addresPrintProducts[i]['add_date'] = 5
          } else if (copiesNum <= 85000) {
            addresPrintProducts[i]['add_date'] = 6
          } else {
            addresPrintProducts[i]['add_date'] = 7
          }
        }

        updateAddresPrintPrices()
        updateSku()

        //折り方が選択肢になければ、stepから削除
        if (!$('input[name="flextype"]').length) {
          selectedProductData.remove('flextype')
        }

        $window.trigger('optionschange')
      }

      initProductDetail()

      /**
       * フォームのデータを取得して、selectedProductData に設定します
       * @param {Element} self - 対象フォームの要素
       */
      const setValues = self => {
        const $self = $(self)
        /**
         * 変更されたフォームのname属性値
         * @type {String}
         */
        const name = $self.attr('name')
        /**
         * 変更されたフォームのデータ
         * @type {Object}
         */
        const args = {
          "label": $self.data('note') ? $self.val() + '<small>' + $self.data('note') + '</small>' : $self.val(),
          "id": $self.data('id'),
          "price": $self.data('price')
        }
        switch(name) {
          case 'reqMethod':
            selectedProductData.set(name, changeReqMethod())
            break;
          case 'plan':
            selectedProductData.set(name, changePlan())
            break;
          case 'weight':
            selectedProductData.set(name, changeWeight())
            updatePrices()
            updateAddresPrintPrices()
            updateSku()
            break;
          default:
            selectedProductData.set(name, args)
        }
        $window.trigger('optionschange')
      }
      
      /**
       * オプションの選択・変更をした時の動作
       */
      $('input[name="weight"], input[name="plan"], input[name="reqMethod"], input[name="flextype"], input[name="paper"], input[name="cuttype"], input[name="delivery"]').on('change', e => {
        setValues(e.target)
      })
      .filter(':checked').each((i, element) => {
        setValues(element)
      })
      
      /**
       * 各ステップの「選択を変更」をクリックしたときの動作
       */
      $('.js-stepNext').on('click', e => {
        let $self = $(e.target)
        let $parent = $self.closest('.orderStep__item')
        $self.closest('.orderStep__item').removeClass('is-current')
        if (selectedProductData.step === 1) {
          gotoStep2()
          selectedProductData.step_checked.step1 = true
        } else if (selectedProductData.step === 2) {
          gotoStep3()
        }
        $window.trigger('optionschange')
      })

      /**
       * 部数・納期を選択したときの動作
       */
      $('.js-selectProduct').on('click', function () {
        const $self = $(this)
        const selfData = $self.data('skuinfo')
        const productData = products[selectedProductData.get('weight').label].find(selfData.copies, selfData.course)
        const selectedProductDataSku = {
          "id": products[selectedProductData.get('weight').label].id,
          "label": productData.copies + '枚 ' + productData.course,
          "price": productData.price,
          "sku_id": productData.id,
          "copies": productData.copies,
          "course": productData.course
        }
        $('.js-productSkuLabel').text(selectedProductDataSku.label)
        $('.js-productAddedDate').text(addresPrintProducts[selfData.copies].add_date)
        if (selectedProductData.address_print.is_active) {
          $('.popup__addedDate').show()
          $('.js-productPrice').text(setComma(selectedProductDataSku.price + addresPrintProducts[selfData.copies].price))
        } else {
          $('.popup__addedDate').hide()
          $('.js-productPrice').text(setComma(selectedProductDataSku.price))
        }
        $('.popup').addClass('is-active')

        $('.js-popupSubmit').on('click', () => {
          $('.js-popupSubmit').off('click')
          selectedProductData.set('sku', selectedProductDataSku)
          selectedProductData.address_print.sku_id = addresPrintProducts[selfData.copies].id
          selectedProductData.address_print.add_date = addresPrintProducts[selfData.copies].add_date
          selectedProductData.address_print.label = selfData.copies
          $('.js-selectProduct').removeClass('is-selected')
          $self.addClass('is-selected')
          updateFormSkuInput(selectedProductDataSku.sku_id)
          selectedProductData.step_checked.step2 = true
          $window.trigger('optionschange')
          $('.popup').removeClass('is-active')
        })
      })

      /**
       * 「カートに入れる」ボタンを押したときの動作
       */
      $('.js-cartInButton').on('click', () => {
        if (!$('.js-cartInButton').hasClass('is-disabled')) {
          const submitCartIn = () => {
            $('#cartinForm').trigger('submit')
          }
          if (selectedProductData.address_print.is_active) {
            $.ajax({
              url: addressPrintCartAddUrl,
              method: 'POST',
              data: {
                product_sku_id: selectedProductData.address_print.sku_id,
                quantity: 1
              },
              beforeSend: function () {
                $('.js-cartInButton')
                  .addClass('is-disabled')
                  .prop('disabled', true)
                $('.l-loader').fadeIn()
              }
            }).done(function (data, textStatus, jqXHR) {
              if (data.responseCode == '400') {
                alert('申し訳ございません、システムに問題が発生いたしました。しばらく経ってから、もう一度手続きをお願いします。')
                $('.js-cartInButton')
                  .removeClass('is-disabled')
                  .prop('disabled', false)
                $('.l-loader').fadeOut()
              } else {
                submitCartIn()
              }
            }).fail(function () {
              alert('申し訳ございません、通信に問題が発生いたしました。しばらく経ってから、もしくは通信環境の良い場所へ移動後、もう一度手続きをお願いします。')
              $('.js-cartInButton')
                .removeClass('is-disabled')
                .prop('disabled', false)
              $('.l-loader').fadeOut()
            })
          } else {
            submitCartIn()
          }
        } else {
          return false
        }
      })

    } else {
      // 刷本支給の選択フォーム

      // 刷り本支給注意事項ポップアップを表示
      $('.popupNotice').addClass('is-active')

      // 依頼方法「刷り本支給」を押した時
      $('.js-reqMethodChecked').on('click', () => {
        $('.popupNotice').addClass('is-active')
      })

      // 刷り本支給注意事項ポップアップの「圧着テスト済み」を押した時
      $('.js-popupNoticeClose').on('click', () => {
        $('.popupNotice').removeClass('is-active')
      })

      /**
      * 選択されている商品のデータ
      * @type {Object}
      */
      let selectedProductData = {
      "step": 1, // 選択中のステップ
      "step_checked": {
        "step1": false,
        "step2": false,
        "step3": false
      },
      "step_selected": [
        // STEP1
        {
          "reqMethod": false, // 依頼方法
          "weight": {
            "label": $('input[name="weight"]:checked').val(),
            "product_id": $('input[name="weight"]:checked').data('product'),
            "price": 0
          }, // 用紙厚さ
          "plan": false, // 印刷プラン
          "flextype": false // 折り方
        },
        // STEP2
        {
          "sku": false // 部数・納期（商品本体）
        },
        // STEP3
        {
          "paper": false, // 用紙の種類
          "cuttype": false, // 加工タイプ
          "delivery": false // 納品方法
        }
      ],
      "address_print" : {
        "is_active": false, // 宛名印字が有効ならtrue
        "sku_id": false, // 宛名印字の SKU ID
        "add_date": false, // 宛名印字の追加納期
        "label": false // 宛名印字の追加納期
      },
      /**
       * オブジェクト内から、該当キーを検索しプロパティを取得
       * @param  {String} key 検索するキー
       * @return {Object|Boolean} 該当キーのプロパティの値。該当キーが見つからない場合、falseを返す
       */
      "get": function (key) {
        let _self = this
        let target = _self.find(key)
        if (target) {
          return target.parent[target.key]
        } else {
          return false
        }
      },
      /**
       * オブジェクト内から、該当キーを検索し指定のプロパティを設定
       * @param  {String} key 検索するキー
       * @param  {Object} value 設定するプロパティ
       * @return {Boolean} 設定できたらtrue、該当キーが見つからない場合はfalseを返す
       */
      "set": function (key, value) {
        let _self = this
        let target = _self.find(key)
        if (target) {
          target.parent[target.key] = value;
          return true
        } else {
          return false
        }
      },
      /**
       * オブジェクト内から、該当キーを検索し削除
       * @param  {String} key 検索するキー
       * @return {Boolean} 削除できたらtrue、該当キーが見つからない場合はfalseを返す
       */
      "remove": function (key) {
        let _self = this
        let target = _self.find(key)
        if (target) {
          delete target.parent[target.key];
          return true
        } else {
          return false
        }
      },
      /**
       * オブジェクト内から、該当キーを検索
       * @param  {String} key 検索するキー
       * @return {Object|Boolean} 該当キーが見つかったら、該当キーの親オブジェクトとキーをオブジェクトに格納して返し、見つからなければfalseを返す
       */
      "find": function(key) {
        let _self = this
        for (let i in _self) {
          if (i === key) {
            return {
              "parent": _self,
              "key": i
            }
          }
          if (Array.isArray(_self[i])) {
            for (let ii = 0; ii < _self[i].length; ii++) {
              for (let iii in _self[i][ii]) {
                if (iii === key) {
                  return {
                    "parent": _self[i][ii],
                    "key": iii
                  }
                }
              }
            }
          }
        }
        return false;
      }
    }
    
    //オプション商品のフォーム設定
    const setAddionsForm = () => {
      $('#addions').empty()
      $('input[data-id]:checked').each(function () {
        const $self = $(this)
        $('#addions').append('<input type="hidden" name="addition_quantity[' + $self.data('id') + ']" value="1">')
      })
    }

    // 部数・納期一覧の価格を更新
    const updatePrices = () => {
      $('.selectTable__price').each(function() {
        let $self = $(this)
        let selfData = $self.parent().data('skuinfo')
        $self.text(setComma(products[selectedProductData.get('weight').label].find(selfData.copies).price))
      });
      $('.selectTable__reserve').each(function() {
        let $self = $(this)
        let selfData = $self.data('skuinfo')
        $self.text(setComma(products[selectedProductData.get('weight').label].find(selfData.copies).reserve))
      });
      $('.selectTable__course').each(function() {
        let $self = $(this)
        let selfData = $self.data('skuinfo')
        $self.text(setComma(products[selectedProductData.get('weight').label].find(selfData.copies).course))
      });
    }

    // 宛名印字の価格を更新
    const updateAddresPrintPrices = () => {
      $('.selectTable__price--hasAddress').each(function() {
        let $self = $(this)
        let selfData = $self.parent().data('skuinfo')
        let price = products[selectedProductData.get('weight').label].find(selfData.copies).price
        $self.text(setComma(price + addresPrintProducts[selfData.copies].price))
      });
    }

    // SKU Update
    const updateSku = () => {
      if ($('.js-selectProduct.is-selected').length) {
        let selfData = $('.js-selectProduct.is-selected').data('skuinfo')
        let selectedProduct = products[selectedProductData.get('weight').label].find(selfData.copies)
        selectedProductData.set('sku', {
          "id": products[selectedProductData.get('weight').label].id,
          "label": selectedProduct.copies + '枚 ' + selectedProduct.course,
          "price": selectedProduct.price,
          "sku_id": selectedProduct.id,
          "copies": selectedProduct.copies,
          "course": selectedProduct.course,
          "reserve" : selectedProduct.reserve
        })
        updateFormSkuInput(selectedProduct.id)
      }
      $('#cartinForm').attr('action', products[selectedProductData.get('weight').label].cart_add_url)
    }

    /**
     * 用紙の種類「お任せコース」確認
     */
    const checkPaperRandom = () => {
      /**
       * @type {jQuery} 用紙の種類「お任せコース」チェックボックスのjQueryオブジェクト
       */
      const $paperRandom = $('#paperRandom')
      if ($paperRandom.length) {
        const selectedProductDataSku = selectedProductData.get('sku')
        if (selectedProductDataSku) {
          // 部数・納期で「5日出荷」が選択されていたときの処理
          if (selectedProductDataSku.course === '5日出荷') {
            // 例外に該当する場合の処理
            if (selectedProductDataSku.id in exceptionPaperRandom) {
              if (exceptionPaperRandom[selectedProductDataSku.id] <= Number(String(selectedProductDataSku.copies).replace(',', ''))) {
                cancelPaperRandom()
              } else {
                setPaperRandom()
              }
            } else {
              setPaperRandom()
            }
          } else {
            cancelPaperRandom()
          }
        }
      }
      /**
       * 「お任せコース」に用紙の種類を固定
       */
      function setPaperRandom () {
        $('input[name="paper"]').not($paperRandom)
          .prop('checked', false)
          .addClass('is-disabled')
          .attr('disabled', true)
        $paperRandom
          .prop('checked', true)
          .trigger('click')
        selectedProductData.set('paper', {
          "label": $paperRandom.val(),
          "id": $paperRandom.data('id'),
          "price": $paperRandom.data('price')
        })
      }
      /**
       * 「お任せコース」への用紙の種類固定を解除
       */
      function cancelPaperRandom () {
        $('input[name="paper"]').not($paperRandom)
          .removeClass('is-disabled')
          .attr('disabled', false)
      }
    }

    /**
     * 依頼方法を選択したときの動作
     */
      const changeReqMethod = () => {
      const $selectedReqMethod = $('input[name="reqMethod"]:checked')
      return {
        "label": $selectedReqMethod.val(),
        "product_id": $selectedReqMethod.data('product'),
        "price": 0
      }
    }

    /**
     * 用紙厚さを選択したときの動作
     */
    const changeWeight = () => {
      const $selectedWeight = $('input[name="weight"]:checked')
      $('.js-changeWeight').text($selectedWeight.val())
      return {
        "label": $selectedWeight.val(),
        "product_id": $selectedWeight.data('product'),
        "price": 0
      }
    }

    /**
     * 印刷プランを選択したときの動作
     */
    const changePlan = () => {
      const $selectedPlan = $('input[name="plan"]:checked')
      /**
       * 選択された印刷プラン名
       * @type {String}
       */
      const label = $selectedPlan.val()
      if (label === '印刷・圧着・発送まで') {
        selectedProductData.address_print.is_active = false;
        $('.selectTable__price').show()
        $('.selectTable__price--hasAddress').hide()
      } else {
        selectedProductData.address_print.is_active = true;
        $('.selectTable__price').hide()
        $('.selectTable__price--hasAddress').show()
      }
      if (label == '投函まで') {
        $('#addions').append('<input type="hidden" name="addition_quantity[' + $selectedPlan.data('id') + ']" value="1">')
        return {
          "label": label + '<small>' + $('#planToPost').data('note') + '</small>',
          "id": $selectedPlan.data('id'),
          "price": $selectedPlan.data('price')
        }
      } else {
        return {
          "label": label,
          "price": 0
        }
      }
    }

    /**
     * カートインエリアの内容を更新
     */
    const updateCartInArea = () => {
      for (let i = 0; i < selectedProductData.step_selected.length; i++) {
        for (var ii in selectedProductData.step_selected[i]) {
          let $target = $('[data-name="' + ii + '"]');
          if (selectedProductData.step_selected[i][ii]) {
            if ($target.data('name') === 'sku' && selectedProductData.address_print.is_active) {
              // 宛名が有効の場合、宛名の追加納期を「部数・納期」のラベルに追加
              $target.find('.js-selectedLabel')
                .html('<span style="font-size:1.7rem">' + selectedProductData.step_selected[i][ii].label + '</span>'
                  + '<br/><small>' 
                  + selectedProductData.step_selected[i][ii].reserve 
                  + '（' + products[selectedProductData.get('weight').label].pages + '）' 
                  + '</small>' 
                  + '<small>(宛名の追加納期: +' + selectedProductData.address_print.add_date + '日)</small>')
                .removeClass("is-unselected")
              $target.find('.js-selectedPrice').text(setComma(selectedProductData.step_selected[i][ii].price + addresPrintProducts[selectedProductData.address_print.label].price))
            } else {
              // if ($target.data('name') === 'paper') {
              //   // 「用紙の種類」のラベルに、用紙の厚さを追記
              //   $target.find('.js-selectedLabel')
              //     .html(selectedProductData.step_selected[i][ii].label + selectedProductData.get('weight').label)
              //     .removeClass("is-unselected")
              // } else {
                $target.find('.js-selectedLabel')
                  .html(selectedProductData.step_selected[i][ii].label)
                  .removeClass("is-unselected")
              // }
              if ($target.data('name') === 'sku') {
                $target.find('.js-selectedLabel')
                  .html('<span style="font-size:1.7rem">' + selectedProductData.step_selected[i][ii].label  + '</span>' + '<br/><small>' + selectedProductData.step_selected[i][ii].reserve + '（' + products[selectedProductData.get('weight').label].pages + '）' + '</small>')
                  .removeClass("is-unselected")
              }
              $target.find('.js-selectedPrice').text(setComma(selectedProductData.step_selected[i][ii].price))
            }
          } else {
            $target.find('.js-selectedLabel')
              .html('未選択')
              .addClass("is-unselected")
            $target.find('.js-selectedPrice').text('-')
          }
        }
      }
    }

    /**
     * STEP 2 へ移動
    */
    const gotoStep2 = () => {
      selectedProductData.step = 2
    }

    /**
     * STEP 3 へ移動
    */
    const gotoStep3 = () => {
      selectedProductData.step = 3
    }

    /**
     * ステップの進行状況を確認
     */
    const checkStep = () => {
      let isCompleted = {
        "step1": true,
        "step2": true,
        "step3": true
      }
      for (let key in selectedProductData.step_selected[0]) {
        if (!selectedProductData.step_selected[0][key]) {
          isCompleted.step1 = false
        }
      }
      for (let key in selectedProductData.step_selected[1]) {
        if (!selectedProductData.step_selected[1][key]) {
          isCompleted.step2 = false
        }
      }
      for (let key in selectedProductData.step_selected[2]) {
        if (!selectedProductData.step_selected[2][key]) {
          isCompleted.step3 = false
        }
      }
      if(selectedProductData.step_checked.step1) {
        $('.orderStatus').eq(0).addClass('is-checked')
      }
      if (isCompleted.step1) {
        if (selectedProductData.step === 1) {
          if (!isCompleted.step2) {
            gotoStep2()
          } else {
            if (!isCompleted.step3) {
              gotoStep3()
            }
          }
        }
      }
      if(selectedProductData.step_checked.step2) {
        $('.orderStatus').eq(1).addClass('is-checked')
      }
      if (isCompleted.step2) {
        if (selectedProductData.step === 2) {
          if (!selectedProductData.step_checked.step3) {
            gotoStep3()
            selectedProductData.step_checked.step3 = true
          }
        }
      }
      if (selectedProductData.step_checked.step2) {
        $('.orderStatus').eq(2).addClass('is-checked')
      }
      if (isCompleted.step1 && isCompleted.step2 &&isCompleted.step3) {
        let totalPrice = 0
        for (let i = 0; i < selectedProductData.step_selected.length; i++) {
          for (let ii in selectedProductData.step_selected[i]) {
            totalPrice += selectedProductData.step_selected[i][ii].price
          }
        }
        if (selectedProductData.address_print.is_active) {
          totalPrice += addresPrintProducts[selectedProductData.address_print.label].price
        }
        $('.js-totalPrice').text(setComma(totalPrice))
        $('.js-cartInButton')
          .removeClass('is-disabled')
          .prop('disabled', false)
      } else {
        $('.js-totalPrice').text('-')
        $('.js-cartInButton')
          .addClass('is-disabled')
          .prop('disabled', true)
      }
    }

    // フォーム変更時に実行するスクリプト
    $window.on('optionschange', () => {
      checkPaperRandom()
      updateCartInArea()
      checkStep()
      setAddionsForm()
    })

    /**
     * 起動時に実行するスクリプト
     */
    const initProductDetail = () => {
      //宛名印字の追加納期を設定
      for (let i in addresPrintProducts) {
        let copiesNum = Number(String(i).replace(',', ''))
        if (copiesNum <= 20000) {
          addresPrintProducts[i]['add_date'] = 2
        } else if (copiesNum <= 40000) {
          addresPrintProducts[i]['add_date'] = 3
        } else if (copiesNum <= 50000) {
          addresPrintProducts[i]['add_date'] = 4
        } else if (copiesNum <= 60000) {
          addresPrintProducts[i]['add_date'] = 5
        } else if (copiesNum <= 85000) {
          addresPrintProducts[i]['add_date'] = 6
        } else {
          addresPrintProducts[i]['add_date'] = 7
        }
      }

      updateAddresPrintPrices()
      updateSku()

      //折り方が選択肢になければ、stepから削除
      if (!$('input[name="flextype"]').length) {
        selectedProductData.remove('flextype')
      }

      $window.trigger('optionschange')
    }

    initProductDetail()

    /**
     * フォームのデータを取得して、selectedProductData に設定します
     * @param {Element} self - 対象フォームの要素
     */
    const setValues = self => {
      const $self = $(self)
      /**
       * 変更されたフォームのname属性値
       * @type {String}
       */
      const name = $self.attr('name')
      /**
       * 変更されたフォームのデータ
       * @type {Object}
       */
      const args = {
        "label": $self.data('note') ? $self.val() + '<small>' + $self.data('note') + '</small>' : $self.val(),
        "id": $self.data('id'),
        "price": $self.data('price')
      }
      switch(name) {
        case 'reqMethod':
          selectedProductData.set(name, changeReqMethod())
          break;
        case 'plan':
          selectedProductData.set(name, changePlan())
          break;
        case 'weight':
          selectedProductData.set(name, changeWeight())
          updatePrices()
          updateAddresPrintPrices()
          updateSku()
          break;
        default:
          selectedProductData.set(name, args)
      }
      $window.trigger('optionschange')
    }
    
    /**
     * オプションの選択・変更をした時の動作
     */
    $('input[name="weight"], input[name="plan"], input[name="reqMethod"], input[name="flextype"], input[name="paper"], input[name="cuttype"], input[name="delivery"]').on('change', e => {
      setValues(e.target)
    })
    .filter(':checked').each((i, element) => {
      setValues(element)
    })
    
    /**
     * 各ステップの「選択を変更」をクリックしたときの動作
     */
    $('.js-stepNext').on('click', e => {
      let $self = $(e.target)
      let $parent = $self.closest('.orderStep__item')
      if (selectedProductData.step === 1) {
        gotoStep2()
        selectedProductData.step_checked.step1 = true
      } else if (selectedProductData.step === 2) {
        gotoStep3()
      }
      $window.trigger('optionschange')
    })

    /**
     * 部数・納期を選択したときの動作
     */
    $('.js-selectProduct').on('click', function () {
      const $self = $(this)
      const selfData = $self.data('skuinfo')
      const productData = products[selectedProductData.get('weight').label].find(selfData.copies)
      const selectedProductDataSku = {
        "id": products[selectedProductData.get('weight').label].id,
        "label": productData.copies + '枚 ' + productData.course,
        "price": productData.price,
        "sku_id": productData.id,
        "copies": productData.copies,
        "course": productData.course,
        "reserve": productData.reserve
      }
      $('.js-productSkuLabel').text(selectedProductDataSku.label)
      $('.js-productAddedDate').text(addresPrintProducts[selfData.copies].add_date)
      if (selectedProductData.address_print.is_active) {
        $('.popup__addedDate').show()
        $('.js-productPrice').text(setComma(selectedProductDataSku.price + addresPrintProducts[selfData.copies].price))
      } else {
        $('.popup__addedDate').hide()
        $('.js-productPrice').text(setComma(selectedProductDataSku.price))
      }
      $('.popup').addClass('is-active')

      $('.js-popupSubmit').on('click', () => {
        $('.js-popupSubmit').off('click')
        selectedProductData.set('sku', selectedProductDataSku)
        selectedProductData.address_print.sku_id = addresPrintProducts[selfData.copies].id
        selectedProductData.address_print.add_date = addresPrintProducts[selfData.copies].add_date
        selectedProductData.address_print.label = selfData.copies
        $('.js-selectProduct').removeClass('is-selected')
        $self.addClass('is-selected')
        updateFormSkuInput(selectedProductDataSku.sku_id)
        selectedProductData.step_checked.step2 = true
        $window.trigger('optionschange')
        $('.popup').removeClass('is-active')
      })
    })

    /**
     * 「カートに入れる」ボタンを押したときの動作
     */
    $('.js-cartInButton').on('click', () => {
      if (!$('.js-cartInButton').hasClass('is-disabled')) {
        const submitCartIn = () => {
          $('#cartinForm').trigger('submit')
        }
        if (selectedProductData.address_print.is_active) {
          $.ajax({
            url: addressPrintCartAddUrl,
            method: 'POST',
            data: {
              product_sku_id: selectedProductData.address_print.sku_id,
              quantity: 1
            },
            beforeSend: function () {
              $('.js-cartInButton')
                .addClass('is-disabled')
                .prop('disabled', true)
              $('.l-loader').fadeIn()
            }
          }).done(function (data, textStatus, jqXHR) {
            if (data.responseCode == '400') {
              alert('申し訳ございません、システムに問題が発生いたしました。しばらく経ってから、もう一度手続きをお願いします。')
              $('.js-cartInButton')
                .removeClass('is-disabled')
                .prop('disabled', false)
              $('.l-loader').fadeOut()
            } else {
              submitCartIn()
            }
          }).fail(function () {
            alert('申し訳ございません、通信に問題が発生いたしました。しばらく経ってから、もしくは通信環境の良い場所へ移動後、もう一度手続きをお願いします。')
            $('.js-cartInButton')
              .removeClass('is-disabled')
              .prop('disabled', false)
            $('.l-loader').fadeOut()
          })
        } else {
          submitCartIn()
        }
      } else {
        return false
      }
    })

    }

    /*-- ↑↑ここまで商品選択のスクリプト↑↑ --*/

  })

})(jQuery)